import type { Booking } from '../../store/schema/Booking';
import type { GetAppointmentResponse } from 'bookings-shared/lib/c2/services/schema/getAppointment';
import type { UpdateAppointmentResponse } from 'bookings-shared/lib/c2/services/schema/updateAppointment';
import type { CreateAppointmentResponse } from 'bookings-shared/lib/c2/services/schema/createAppointment';
import { mapLocation } from './mapLocation';
import { onlineLocationPlaceholder } from '../attendeeConstants.locstring.json';
import loc from 'owa-localize';

export const mapAppointmentResponse = (
    response: GetAppointmentResponse | UpdateAppointmentResponse | CreateAppointmentResponse
): Booking => {
    const {
        serviceId,
        staffMemberIds,
        startTime,
        customers,
        duration,
        serviceName,
        serviceLocation,
        selfServiceAppointmentId,
        isLocationOnline,
    } = response.appointment;

    return {
        Id: selfServiceAppointmentId ?? '',
        AnsweredQuestionList: [], //Custom Questions not supported
        CustomerEmail: customers?.[0]?.emailAddress ?? '',
        CustomerName: customers?.[0]?.name ?? '',
        CustomerNotes: customers?.[0]?.notes,
        CustomerTimeZone: startTime?.timeZone ?? '',
        FormattedDuration: mapFormattedDuration(duration),
        Location: serviceLocation?.displayName
            ? mapLocation(serviceLocation)
            : isLocationOnline
            ? loc(onlineLocationPlaceholder)
            : '',
        ServiceId: serviceId ?? '',
        ServiceName: serviceName ?? '',
        StaffList: staffMemberIds?.[0] ?? '',
        Start: startTime?.dateTime ?? '',
        StartInCustomerTimeZone: startTime?.dateTime ?? '',
    };
};

const mapFormattedDuration = (duration: string | undefined): string => {
    if (duration) {
        const seconds = parseInt(duration);
        const inMinutes = Math.floor(seconds / 60);
        return `${inMinutes} minutes`;
    }
    return '';
};
